import {
  inferAdditionalFields,
  organizationClient,
} from "better-auth/client/plugins";
import {
  Team as BetterAuthTeam,
  InferInvitation,
  InferMember,
  InferOrganizationRolesFromOption,
} from "better-auth/plugins";
import { createAuthClient } from "better-auth/react";

import type { auth } from "./auth";

// Extend the Member type to include teamId
export type Member = InferMember<any> & {
  teamId?: string;
};
export type Invitation = InferInvitation<any> & {
  teamId?: string;
};
export type Team = BetterAuthTeam;

export const authClient = createAuthClient({
  plugins: [
    inferAdditionalFields<typeof auth>(),
    organizationClient({
      teams: {
        enabled: true,
      },
    }),
  ],
});
